const baseURL = window.location.protocol + "//" + window.location.host;
const currentCulture = document.body.getAttribute('data-current-culture');
const siteId = document.body.getAttribute('data-site-id');

export const GetProductById = async (productId) => {
	try {
		const response = await fetch(`${baseURL}/api/products/producttests(${productId})?$expand=ProductSets&sf_culture=${currentCulture}&sf_site=${siteId}`);
		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		console.log(err);
		return err;
	}
};

export const GetProductSetById = async (productSetId) => {
	try {
		const response = await fetch(`${baseURL}/api/products/ProductSets(${productSetId})?$expand=ProductSetItems&sf_culture=${currentCulture}&sf_site=${siteId}`);
		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		console.log(err);
		return err;
	}
};

export const GetProductSetItemsById = async (productSetItemId) => {
	try {
		const response = await fetch(`${baseURL}/api/products/ProductSetItems(${productSetItemId})?$expand=Images&sf_culture=${currentCulture}&sf_site=${siteId}`);
		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		console.log(err);
		return err;
	}
};

export const GetProductSetItemsWithBenefits = async (productSetItemId) => {
	try {
		const response = await fetch(`${baseURL}/api/products/ProductSetItems(${productSetItemId})?$expand=Benefits&sf_culture=${currentCulture}&sf_site=${siteId}`);
		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		console.log(err);
		return err;
	}
};


export const GetBenefitWithIcon = async (productSetItemId) => {
	try {
		const response = await fetch(`${baseURL}/api/products/Benefits(${productSetItemId})?$expand=Icon&sf_culture=${currentCulture}&sf_site=${siteId}`);
		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		console.log(err);
		return err;
	}
};

export const GetHotspot = async (hotspotId) => {
	try {
		const response = await fetch(`${baseURL}/api/hotspots/hotspots(${hotspotId})/FeaturedImage?sf_culture=${currentCulture}&sf_site=${siteId}`);
		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		console.log(err);
		return err;
	}
};

export const GetHotspotFeaturedImage = async (hotspotId) => {
	try {
		const response = await fetch(`${baseURL}/api/hotspots/hotspots(${hotspotId})/FeaturedImage?sf_culture=${currentCulture}&sf_site=${siteId}`);
		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		console.log(err);
		return err;
	}
};

export const GetHotspotItems = async (hotspotId) => {
	try {
		const response = await fetch(`${baseURL}/api/hotspots/hotspots(${hotspotId})/HotspotItems?$expand=MobileHotspotImage&sf_culture=${currentCulture}&sf_site=${siteId}`);
		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		console.log(err);
		return err;
	}
};


export const GetHotspotBenefits = async (hotspotItemId) => {
	try {
		const response = await fetch(`${baseURL}/api/hotspots/HotspotItems(${hotspotItemId})/Benefits?sf_culture=${currentCulture}&sf_site=${siteId}`);
		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		console.log(err);
		return err;
	}
}


export const GetRecipesForProduct = async (productId) => {
	try {
		const response = await fetch(`${baseURL}/api/products/producttests(${productId})/recipes?$expand=Carouselmage,Image1&&sf_culture=${currentCulture}&sf_site=${siteId}`);
		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		console.log(err);
		return err;
	}
};


export const GetRecipeCategories = async (taxId) => {
	try {
		const response = await fetch(`${baseURL}/api/recipes/taxonomies(${taxId})&sf_culture=${currentCulture}&sf_site=${siteId}`);
		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		console.log(err);
		return err;
	}
};

export const GetAllMagazines = async () => {
	try {
		const response = await fetch(`${baseURL}/api/magazines/magazines?sf_culture=${currentCulture}&sf_site=${siteId}`);
		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		console.log(err);
		return err;
	}
};

export const GetMagazineImage = async (key) => {
	try {
		const response = await fetch(`${baseURL}/api/magazines/magazines(${key})/Image?$select=Url,AlternativeText&sf_culture=${currentCulture}&sf_site=${siteId}`);
		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		console.log(err);
		return err;
	}
};

export const GetMagazineDocument = async (key) => {
	try {
		const response = await fetch(`${baseURL}/api/magazines/magazines(${key})/Pdf?$select=Url&sf_culture=${currentCulture}&sf_site=${siteId}`);
		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		console.log(err);
		return err;
	}
};

export const GetBlogsForProduct = async (productId) => {
	try {
		const response = await fetch(`${baseURL}/api/products/producttests(${productId})/blogs?$expand=image,HomeImage&sf_culture=${currentCulture}&sf_site=${siteId}`);
		
		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		console.log(err);
		return err;
	}
};
